import { makeStyles } from "@material-ui/core";

export const TypographyVariants = makeStyles((theme) => ({
    bold: {
        fontWeight: 700,
    },
    title: {
        color: "rgb(34, 34, 34)",
        fontSize: "1rem",
        fontWeight: 600,
        lineHeight: "25.6px",
        margin: "15px 0 0 0",
    },
    userExplanation: {
        paddingTop: "15px",
        fontSize: "15px",
        lineHeight: "24px",
    },
    rulertel: {
        color: "#c70101",
    },
    gform_title: {
        /* fontSize: "1.25rem",
        fontWeight: 700,
        fontFamily: "Nexa Bold", */
    },
    gform_description: {
        fontSize: "1rem",
        fontWeight: 400,
        marginBottom: "16px",
        lineHeight: "24px",
    },
    gfield_label: {
        color: "#c70101",
        fontWeight: 600,
        fontSize: "1rem",
    },
    gfield_description: {
        fontSize: "0.81rem",
        lineHeight: "19.4px",
        paddingRight: "16px",
        textAlign: "left",
    },
    productSelectorh1: {
        paddingBottom: "15px",
    },
    productSelectorh2: {
        paddingBottom: "10px",
    },
    productSelectorUnderlineh2: {
        position: "relative",
        marginBottom: "30px",
        "&::before": {
            content: "''",
            position: "absolute",
            bottom: "-15px",
            left: "0",
            width: "80px",
            height: "3px",
            background: "#000",
        },
    },
    productSelectorbody1: {
        fontFamily: "Nexa",
        fontSize: "14px",
    },
}));
